import React from 'react';
import pic1 from '../img/Clinic/clinic1.jpg';
import pic2 from '../img/Clinic/clinic2.jpg';
import pic3 from '../img/Clinic/clinic3.jpg';
import pic4 from '../img/Clinic/clinic4.jpg';
import pic5 from '../img/Clinic/clinic5.jpg';
import pic6 from '../img/Clinic/clinic6.jpg';
import pic7 from '../img/Clinic/clinic7.jpg';
import pic8 from '../img/Clinic/clinic8.jpg';
import pic9 from '../img/Clinic/clinic9.jpg';
import pic10 from '../img/Clinic/clinic10.jpg';
import pic11 from '../img/Clinic/clinic11.jpg';
import pic12 from '../img/Clinic/clinic12.jpg';
import pic13 from '../img/Clinic/clinic13.jpg';
// import '../../node_modules/react-responsive-carousel/lib/styles/carousel.min.css';
// import { Carousel } from 'react-responsive-carousel';
import Carousel from 'react-gallery-carousel';
import '../../node_modules/react-gallery-carousel/dist/index.css';

const Clinic = () => {
	const images = [
		{
			src: pic1,
			sizes: '(max-width: 500px) 300px ,(max-width: 1000px) 400px, (max-width: 2000px) 700px, 1000px'
		},
		{
			src: pic2,
			sizes: '(max-width: 500px) 300px ,(max-width: 1000px) 400px, (max-width: 2000px) 700px, 1000px'
		},
		{
			src: pic3,
			sizes: '(max-width: 500px) 300px ,(max-width: 1000px) 400px, (max-width: 2000px) 700px, 1000px'
		},
		{
			src: pic4,
			sizes: '(max-width: 500px) 300px ,(max-width: 1000px) 400px, (max-width: 2000px) 700px, 1000px'
		},
		{
			src: pic5,
			sizes: '(max-width: 500px) 300px ,(max-width: 1000px) 400px, (max-width: 2000px) 700px, 1000px'
		},
		{
			src: pic6,
			sizes: '(max-width: 500px) 300px ,(max-width: 1000px) 400px, (max-width: 2000px) 700px, 1000px'
		},
		{
			src: pic7,
			sizes: '(max-width: 500px) 300px ,(max-width: 1000px) 400px, (max-width: 2000px) 700px, 1000px'
		},
		{
			src: pic8,
			sizes: '(max-width: 500px) 300px ,(max-width: 1000px) 400px, (max-width: 2000px) 700px, 1000px'
		},
		{
			src: pic9,
			sizes: '(max-width: 500px) 300px ,(max-width: 1000px) 400px, (max-width: 2000px) 700px, 1000px'
		},
		{
			src: pic10,
			sizes: '(max-width: 500px) 300px ,(max-width: 1000px) 400px, (max-width: 2000px) 700px, 1000px'
		},
		{
			src: pic11,
			sizes: '(max-width: 500px) 300px ,(max-width: 1000px) 400px, (max-width: 2000px) 700px, 1000px'
		},
		{
			src: pic12,
			sizes: '(max-width: 500px) 300px ,(max-width: 1000px) 400px, (max-width: 2000px) 700px, 1000px'
		},
		{
			src: pic13,
			sizes: '(max-width: 500px) 300px ,(max-width: 1000px) 400px, (max-width: 2000px) 700px, 1000px'
		}
	];
	return (
		<section className="clinic" id="clinic">
			<div className="max-width">
				<h2 className="title">Clinic</h2>
				<div className="clinic-content">
					<Carousel images={images} style={{ height: 700, width: 700 }} />
				</div>
				<br />
				<hr />
				<br />
			</div>
		</section>
	);
};

export default Clinic;
